import request from '@/utils/request'

/**
 * 品牌主详情
 * @param data
 */
export const getUserInfo = (userId) => {
  return request({
    url: `/sol/wap/brand_firm/${userId}`,
    method: 'get'
  })
}

/**
 * 查询用户信息
 * @param uid
 */
export const getUser = (uid) => {
  return request({
    url: `/sol/wap/user/${uid}`,
    method: 'get'
  })
}

/**
 * 更新用户剩余的方案免费下载次数
 */
export const updateFreeDownLoadNum = (data) => {
  return request({
    url: `/sol/wap/user/updateFreeDownLoadNum`,
    method: 'POST',
    data: data
  })
}


// WEBPACK FOOTER //
// ./src/api/user/user.js